(function () {
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* mobile menu */
  var header = $('[data-header]'), toggle = $('[data-menu-toggle]');
  if (header && toggle) toggle.addEventListener('click', function () {
    var open = header.classList.toggle('menu-open');
    toggle.setAttribute('aria-expanded', open);
  });

  /* collection filters: auto-submit */
  var ff = $('[data-filter-form]');
  if (ff) {
    var go = function () {
      var p = new URLSearchParams(new FormData(ff));
      Array.from(p.keys()).forEach(function (k) { if (!p.get(k)) p.delete(k); });
      window.location.search = p.toString();
    };
    $$('input,select', ff).forEach(function (el) { el.addEventListener('change', go); });
  }

  /* money */
  function money(cents, fmt) {
    var v = cents / 100;
    var n = function (x, d) { return x.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), t = m ? m[1] : 'amount', s;
    if (t === 'amount_no_decimals') s = n(v, 0);
    else if (t === 'amount_with_comma_separator') s = v.toFixed(2).replace('.', ',');
    else if (t === 'amount_no_decimals_with_comma_separator') s = n(v, 0).replace(/,/g, '.');
    else s = n(v, 2);
    return m ? fmt.replace(m[0], s) : fmt;
  }

  /* product page */
  var root = $('[data-product]');
  if (root) {
    var variants = JSON.parse($('[data-variants]', root).textContent);
    var fmt = root.getAttribute('data-money');
    var gallery = $('[data-gallery]', root);
    var slides = $$('[data-slide]', gallery), thumbs = $$('[data-thumb]', gallery);
    var show = function (i) {
      slides.forEach(function (s, j) { s.classList.toggle('active', i === j); });
      thumbs.forEach(function (t, j) { t.classList.toggle('active', i === j); });
    };
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

    var idInput = $('[data-variant-id]', root), add = $('[data-add]', root), wrap = $('[data-price-wrap]', root);
    var update = function () {
      var sel = $$('[data-option]', root).map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
      var v = variants.find(function (x) { return sel.every(function (val, i) { return val === x['option' + (i + 1)]; }); });
      if (!v) { add.disabled = true; add.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      add.disabled = !v.available;
      add.textContent = v.available ? 'Add to cart' : 'Sold out';
      wrap.innerHTML = (v.compare_at_price && v.compare_at_price > v.price)
        ? '<s class="was">' + money(v.compare_at_price, fmt) + '</s><span class="now sale">' + money(v.price, fmt) + '</span>'
        : '<span class="now">' + money(v.price, fmt) + '</span>';
      if (v.featured_image && v.featured_image.position) show(v.featured_image.position - 1);
      if (history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
    };
    $$('[data-option] input', root).forEach(function (r) { r.addEventListener('change', update); });

    var qi = $('[data-qty-input]', root);
    $$('[data-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
      });
    });
  }
})();
